import React, { Component } from "react";
import { connect } from "react-redux";
import { navigate } from "@reach/router";
import styled from "styled-components";
import posed from "react-pose";
import SearchFilter from "../components/SearchFilter";
import ModalComponent from "../components/Modal";
import Header from "../components/Header";
import MusicContentCard from "../components/MusicContentCard";
import TextInput from "../components/TextInput";
import {
	doMusicSearch,
	searchInputWholeWord,
	_doRecentSearch,
	searchPerformed
} from "../store/actions";
// import SVGfilter from '../images/filter.svg';

const SignupBar = styled.div`
  width: 100vw;
  height 5rem;
  background-color: white;
  top: 0;
  grid-area: bar;
  display: grid;
  grid-template-areas: 1fr
  justify-content: center;
  & > p {
    padding-right: 1rem;
    padding-left: 1rem;
    line-height: 2rem;
    color: black;
    font-family: 'Open Sans', sans-serif;
    font-weight: 100;
    font-size: 0.85rem;
    & > strong > a {
      color: #C21E3D;
      }
      @media (max-width: 710px) {
        line-height: 1rem;
      }
    }
  }

`;

const WrapperDiv = styled.div`
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: 1fr 2fr 1fr;
	grid-template-rows: ${props => props.style.row1} 100px auto 75px;
	grid-row-gap: 5rem;
	grid-row-gap: 0;
	grid-template-areas:
		"bar bar bar"
		"header header header"
		"body body body"
		"footer footer footer";
	@media (max-width: 700px) {
		grid-row-gap: 0;
	}
`;

const BodyWrapper = styled.div`
	grid-area: body;
	overflow: hidden auto;
	text-align: center;
	display: ${props => props.style.hideDisplay};
	position: relative;
	flex-direction: column;
	align-items: center;
	min-height: calc(100vh - (175px + 10rem + 3rem));
	@media (max-width: 700px) {
		min-height: calc(100vh - 175px);
	}
`;

const BannerText = styled.h1`
	font-family: "Open Sans", sans-serif;
	font-weight: 700;
	font-size: 4rem;
	text-align: center;
	margin-bottom: 0;
	@media (max-width: 700px) {
		font-size: 2rem;
	}
`;

const BodyText = styled.p`
    font-family: 'Open Sans', sans-serif;
    > strong {
        color: white
        font-size: 2rem;
        @media (max-width: 700px) {
            font-size: 1.5rem;
            }
    }
`;

// const FilterSearchButton = styled.button`
//   position: relative;
//   height: 3.2rem;
//   width: 3.2rem;
//   border-radius: 5rem;
//   background-color: red;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   text-align: center;
//   border: none;
//   transition: all 0.5s;
//   &:focus {
//     outline: none;
//   }
//   &:hover {
//     opacity: 0.5;
//     cursor: pointer;
//   }
//   @media (max-width: 700px) {
//     left: 8rem;
//   }
//   @media (min-width: 700px) {
//     width: 14rem;
//     border-radius: 5rem;
//     &::after {
//       content: 'Filter Search';
//       color: white;
//       font-size: 1rem;
//       margin-left: 1rem;
//     }
//   }
// `;

// const FilterSVG = styled.img`
//   width: 1.8rem;
// `;

const HeaderTextconfig = {
	visible: { opacity: 1, scale: 1 },
	hidden: { opacity: 0, scale: 0 },

	transition: { duration: 0 }
};

const StyledBottomSpinner = styled.div`
	position: absolute;
	top: 14rem;
	width: 100vw;
	height: 25vh;
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

const StyledSpinner = styled.div`
	margin-top: 10vh;
	width: 100vw;
	height: 25vh;
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

const StyledLiMasterContainer = styled.div`
	width: 70vw;
	display: grid;
	grid-template-columns: 2fr;
	grid-template-gap: 1rem;
	@media (max-width: 700px) {
		width: 90vw;
		grid-template-columns: 1fr;
	}
`;

const StyledLiContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	& > ul {
		padding: 0px;
		list-style: none;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		text-align: center;
	}
	& > ul > li {
		list-style-type: none;
		float: left;
	}
	& > ul > li > a {
		text-decoration: none;
		color: white;
		font-family: "Open Sans", sans-serif;
		font-size: 1.5rem;
		&:hover {
			text-decoration: underline;
			cursor: pointer;
		}
	}
`;

const PosedHeaderText = posed.div(HeaderTextconfig);
const PosedSearchResultsDiv = posed.div(HeaderTextconfig);

const StyledPosedSearchResultsDivHeader = styled.div`
	height: 30px;
	width: 100%;
	color: #939598;
	font-family: "Open Sans";
	font-size: 24px;
	font-weight: 300;
	line-height: 30px;
	text-align: center;
`;
const StyledPosedSearchResultsDiv = styled(PosedSearchResultsDiv)`
	margin-top: 2rem;
	display: grid;
	overflow: hidden;
	grid-template-columns: 374px 374px;
	grid-template-rows: minmax(max-content, max-content);
	grid-auto-rows: minmax(max-content, max-content);
	grid-gap: 1rem;
	@media (max-width: 700px) {
		grid-template-columns: 90vw;
	}
`;

class Main extends Component {
	state = {
		visible: true,
		displaySearchResults: false,
		modalIsOpen: false,
		showSignUpContents: false,
		isLoggedInHideText: false,
		signupTodayClicked: false
	};

	componentDidMount() {
		this.setState({ displaySearchResults: this.props.music.success });
		this.setState({ displaySearchResults: this.props.music.searchPerformed });
		const s = new URLSearchParams(window.location.search).get("s");
		if (s && s.length) {
			console.debug("Main Component->componentDidMount Search string", s);
			this.props.searchInputWholeWord(s);
		}
		this.doSearch(true, s);
	}

	componentDidUpdate() {
		const { isLoggedIn } = this.props.auth;
		const { isLoggedInHideText } = this.state;

		if (isLoggedIn && !isLoggedInHideText) {
			if (this.props.music.searchPerformed) {
				this.setState({ isLoggedInHideText: true, visible: false });
			} else {
				this.setState({
					isLoggedInHideText: true,
					visible: false,
					displaySearchResults: false
				});
			}
		}

		const s =
			new URLSearchParams(window.location.search).get("s") ||
			this.props.music.search;
		if (this.props.music.searchResults && this.props.music.searchPerformed) {
			this.props.searchPerformed(false);
		} else if (!this.state.visible && !this.props.music.searchPerformed && !s) {
			this.props.searchPerformed(false);
			this.setState({ visible: true, displaySearchResults: false });
		} else if (
			s &&
			s.length &&
			this.props.search &&
			!(this.props.music.search !== s)
		) {
			console.debug(
				"Main Compoenent:->componentDidUpdate->doSearch Search string",
				s
			);
			/**
			 * If we have a string available but there isn't a search performed then perform it now
			 */
			// this.props.searchPerformed(false);
			// this.setState({ visible: false, displaySearchResults: true });
			this.props.searchInputWholeWord(s);
			this.doSearch(false, s);
		}
	}

	doSearch = (firstMount, string) => {
		const s = this.props.music.search || string;
		console.debug("Main Component->doSearch Search string", s);
		if (s && s.length && s.length >= 2) {
			navigate("/?s=" + s);
			this.props.searchPerformed(true);
			this.setState({ displaySearchResults: true });
			this.setState({ isLoggedInHideText: true, visible: false });
			this.props
				.doMusicSearch()
				.then(result => {
					this.setState({ displaySearchResults: true });
				})
				.catch(error => {
					console.log("Main Component: Error", error);
					this.setState({ error: error.message });
				});
		} else if (!firstMount) {
			this.setState({ error: "Please enter a search string" });
		} else {
			this.props._doRecentSearch();
			this.props.searchPerformed(true);
		}
	};

	_toggleHeaderTextVisibility = () => {
		this.setState({ visible: false });
	};

	_openFilterModal = () => {
		this.setState({ modalIsOpen: !this.state.modalIsOpen });
	};

	_passTrackToFooterPlayer = track => {
		this.setState({ showFooterPlayer: track });
	};

	_renderContentCards = () => {
		if (this.props.music.success || this.props.music.searchPerformed) {
			const { items } = this.props.music.searchResults;
			if (items && items.length) {
				return items.map(i => (
					<MusicContentCard
						key={i.id}
						item={i}
						passTrack={this._passTrackToFooterPlayer}
						player={this.props.player}
					/>
				));
			}
			return "";
		}
	};

	_searchTermClickHandler = s => {
		console.log("Main Component: Search String", s);
		if (s && s.length >= 2) {
			this.setState({ error: null });
			this.props.searchInputWholeWord(s);
			this.props.searchPerformed(true);
			this.doSearch();
		} else {
			this.setState({ error: "You need to enter a search string" });
		}
	};

	_handleOnClickSignup = e => {
		if (e) {
			e.preventDefault();
		}
		this.setState(prevState => ({
			signupTodayClicked: !prevState.signupTodayClicked,
			showSignUpContents: true
		}));
	};

	_renderPreviousSearchTerms = () => {
		const { userProfile, isLoggedIn } = this.props.auth;
		const {
			popularSearchResults,
			popularSearchSuccess,
			success
		} = this.props.music;
		if (isLoggedIn && !success && userProfile) {
			const userRecentSearches = userProfile.searches
				? [...userProfile.searches].reverse().slice(0, 5)
				: null;
			return (
				<React.Fragment>
					{userRecentSearches && (
						<StyledLiMasterContainer>
							<StyledLiContainer>
								<StyledPosedSearchResultsDivHeader>
									Your Searches
								</StyledPosedSearchResultsDivHeader>
								<ul>
									{userRecentSearches &&
										userRecentSearches.map(s => (
											<li key={s}>
												<a
													value={s}
													href="#"
													onClick={() => this._searchTermClickHandler(s)}>
													{s}
												</a>
											</li>
										))}
								</ul>
							</StyledLiContainer>
						</StyledLiMasterContainer>
					)}
					<StyledLiMasterContainer>
						<StyledLiContainer>
							<StyledPosedSearchResultsDivHeader>
								Popular Searches
							</StyledPosedSearchResultsDivHeader>
							{popularSearchSuccess ? (
								<StyledPosedSearchResultsDiv>
									{popularSearchResults.top.result.map(r => (
										<MusicContentCard
											key={r.uniqueId}
											item={r}
											player={this.props.player}
										/>
									))}
								</StyledPosedSearchResultsDiv>
							) : (
								""
							)}
						</StyledLiContainer>
					</StyledLiMasterContainer>
				</React.Fragment>
			);
		}
		return null;
	};

	_signupBar = () => {
		const {
			checkingAuth,
			auth: { isLoggedIn }
		} = this.props;

		if (!isLoggedIn && !checkingAuth) {
			return (
				<SignupBar>
					<p>
						To explore all features, such as viewing your recent Coolhand Cues,
						you must first be logged in.
						<strong>
							<a href="#" onClick={this._handleOnClickSignup}>
								{" "}
								Sign up today.
							</a>
						</strong>
					</p>
				</SignupBar>
			);
		}
	};

	render() {
		const { displaySearchResults, visible } = this.state;
		const {
			music,
			checkingAuth,
			auth: { isLoggedIn }
		} = this.props;
		console.log(
			"SEARCH PERFORMED",
			music.searchPerformed,
			"Logged In?",
			isLoggedIn
		);
		return (
			<WrapperDiv
				style={{
					row1: isLoggedIn || checkingAuth ? "0rem" : "4rem"
				}}>
				{!checkingAuth && this._signupBar()}
				<Header
					showSignup={this.state.signupTodayClicked}
					toggleSignupModalFromMain={this._handleOnClickSignup}
				/>
				{checkingAuth && music.loadingBasicSearch && (
					<StyledSpinner>
						<div className="lds-roller">
							<div />
							<div />
							<div />
							<div />
							<div />
							<div />
							<div />
							<div />
						</div>
					</StyledSpinner>
				)}
				{!checkingAuth && (
					<BodyWrapper
						style={{
							hideDisplay: isLoggedIn
								? !music.modalIsOpen
									? "flex"
									: "none"
								: music.modalIsOpen
								? "none"
								: "flex"
						}}>
						{visible && (
							<PosedHeaderText
								pose={!displaySearchResults ? "visible" : "hidden"}>
								<BannerText>
									GET YOUR NEXT <br /> TRACK CUE'D UP <br /> BY COOLHAND
								</BannerText>
								<BodyText>
									<strong>What to play next?</strong>
									<br />
									Find the next track to cue up by searching
									<br /> by Title,Artist,Tempo Key, or Lyrics.
								</BodyText>
							</PosedHeaderText>
						)}
						<TextInput
							style={{ maxWidth: "575px" }}
							placeholder="Get Cue'd Up"
							buttonAction={this.doSearch}
							displaySearchResults={displaySearchResults}
							errorMessage={this.state.error}
						/>
						{!isLoggedIn && !displaySearchResults && (
							<StyledLiContainer>
								<br />
								<StyledPosedSearchResultsDivHeader>
									{!music.searchResults ? "Popular Searches" : ""}
								</StyledPosedSearchResultsDivHeader>
								{!music.searchResults &&
									music.popularSearchSuccess &&
									music.popularSearchResults && (
										<StyledPosedSearchResultsDiv>
											{music.popularSearchResults.top.result.map(r => (
												<MusicContentCard
													key={r.uniqueId}
													item={r}
													passTrack={() => this._searchTermClickHandler(r)}
													player={this.props.player}
												/>
											))}
										</StyledPosedSearchResultsDiv>
									)}
							</StyledLiContainer>
						)}
						{music.loadingBasicSearch && (
							<StyledBottomSpinner>
								<div className="lds-roller">
									<div />
									<div />
									<div />
									<div />
									<div />
									<div />
									<div />
									<div />
								</div>
							</StyledBottomSpinner>
						)}
						{/* beginprevious searches */}
						{!displaySearchResults && this._renderPreviousSearchTerms()}
						{/* end previous searches */}
						<div style={{ marginTop: "6rem" }} />
						{music.success && (
							<StyledPosedSearchResultsDivHeader>
								We've found {this.props.music.searchResults.items.length}{" "}
								results
							</StyledPosedSearchResultsDivHeader>
						)}
						<StyledPosedSearchResultsDiv
							pose={displaySearchResults ? "visible" : "hidden"}
							onPoseComplete={this._toggleHeaderTextVisibility}>
							{music.success && this._renderContentCards()}
						</StyledPosedSearchResultsDiv>
						<ModalComponent isOpen={this.state.modalIsOpen}>
							{<SearchFilter closeModal={this._openFilterModal} />}
						</ModalComponent>
					</BodyWrapper>
				)}
			</WrapperDiv>
		);
	}
}

const mapStateToProps = state => ({
	music: state.music,
	auth: state.auth
});

export default connect(
	mapStateToProps,
	{ doMusicSearch, searchInputWholeWord, _doRecentSearch, searchPerformed }
)(Main);



// WEBPACK FOOTER //
// ./src/screen/Main.js